import React from "react";
import { Form, Input } from "antd";

const formIteam = [
	{
		name: "interno",
		title: "Interno",
		description: "Comentarios más relevantes del Retrospective",
	},
	{
		name: "proveedores",
		title: "Provedores",
		description: "Cómo fue el desempeño del Proveedor | ¿Se recomienda al proveedor?",
	},
	{
		name: "areas",
		title: "Área",
		description: "Tecnologías investigadas o áreas de oportunidad o módulos implementados y/o creados",
	},
];

export const FormIteamOperation = ({ disabled = false }) => {
	return (
		<>
			{formIteam.map((formI, index) => (
				<div key={`${index}-operation`} className="w-full  flex flex-col gap-2">
					<p className="text-[12px] font-bold">{formI.title}</p>
					<p className="text-[10px] text-[#9A9A9A]">{formI.description}</p>
					<Form.Item
						name={["operaciones", formI.name]}
						rules={[
							{
								required: true,
								message: "No puede ir vacio",
							},
						]}
					>
						<Input.TextArea
							placeholder="Comentario"
							autoSize={{
								minRows: 5,
								maxRows: 5,
							}}
							disabled={disabled}
						/>
					</Form.Item>
				</div>
			))}
		</>
	);
};
